import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router"
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
  export class SubscriptionsComponent {
  constructor(public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, public http: HttpClient, private router: Router) {this.ping()}
    loaded: boolean = false;
    siteID = environment.siteID;
    mysubs: any;
    subsTrue: boolean = false;
    public ping() {
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
        let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getSubscriptions?siteID='+this.siteID,{
        headers:myheader
      })
      .subscribe(
        data => {
          this.mysubs = data;
          setTimeout(() => {
            this.loaded = true;
        }, 1500);
         
          
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
    );
    }
    refresh(): void {
      window.location.reload();
  }
    ngOnInit() {
      /** spinner starts on init */
      this.spinner.show();

    }
    ngAfterViewInit() {
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
    }, 1500);
    }
  }